import machineReducer from "./reducers";

export default machineReducer;